"use strict";

exports.__esModule = true;
exports.default = exports.enhance = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _withPropsOnChange = _interopRequireDefault(require("recompose/withPropsOnChange"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _setDisplayName = _interopRequireDefault(require("recompose/setDisplayName"));

var _core = require("@nivo/core");

var _legends = require("@nivo/legends");

var _props = require("./props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

class PieLegends extends _react.Component {
  render() {
    const _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          legends = _this$props.legends,
          data = _this$props.data,
          theme = _this$props.theme;
    return legends.map((legend, i) => _react.default.createElement(_legends.BoxLegendSvg, _extends({
      key: i
    }, legend, {
      containerWidth: width,
      containerHeight: height,
      data: data,
      theme: theme
    })));
  }

}

PieLegends.propTypes = process.env.NODE_ENV !== "production" ? {
  width: _propTypes.default.number.isRequired,
  height: _propTypes.default.number.isRequired,
  arcs: _propTypes.default.arrayOf(_props.arcPropType).isRequired,
  data: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  legends: _propTypes.default.arrayOf(_propTypes.default.shape(_legends.LegendPropShape)).isRequired,
  theme: _core.themePropType.isRequired
} : {};

const enhance = Component => (0, _compose.default)((0, _withPropsOnChange.default)(['arcs'], ({
  arcs
}) => ({
  data: arcs.map(arc => ({
    id: arc.data.id,
    label: arc.data.id,
    color: arc.color,
    fill: arc.fill
  }))
})), _pure.default)(Component);

exports.enhance = enhance;

var _default = (0, _setDisplayName.default)('PieLegends')(enhance(PieLegends));

exports.default = _default;